

import { INSPECTION_ITEM_STATUS_MAP } from '@/shared/constants/statusMaps';
import { InspectionItemStatus } from '@/shared/enums/InspectionStatus';




export const STATUS_COLORS: Record<string, string> = {
  'AguardandoDirecionamento': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.AguardandoDirecionamento].color, 
  'AguardandoAceitePrestadora': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.AguardandoAceitePrestadora].color, 
  'PrestadoraRecusou': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.PrestadoraRecusou].color, 
  'AguardandoDirecionamentoInspetor': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.AguardandoDirecionamentoInspetor].color, 
  'AguardandoAceiteInspetor': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.AguardandoAceiteInspetor].color,
  'InspetorRecusou': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.InspetorRecusou].color, 
  'AguardandoAgendamento': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.AguardandoAgendamento].color, 
  'Agendado': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.Agendado].color, 
  'CheckinRealizado': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.CheckinRealizado].color, 
  'Finalizado': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.Finalizado].color,
  'Cancelado': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.Cancelado].color, 
  'Frustrado': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.Frustrado].color, 
  'LaudoNegadoPorPrestadora': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.LaudoNegadoPorPrestadora].color, 
  'AguardandoRevisaoBanco': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.AguardandoRevisaoBanco].color,
  'LaudoNegadoPorBanco': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.LaudoNegadoPorBanco].color,
  'LaudoAceitoPeloBanco': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.LaudoAceitoPeloBanco].color, 
  'AguardandoRevisaoPrestadora': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.AguardandoRevisaoPrestadora].color, 
  'CorrecaoPeloInspetorBanco': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.CorrecaoPeloInspetorBanco].color,
  'AguardandoGeracaoLaudo': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.AguardandoGeracaoLaudo].color,
  'TelevistoriaAgendada': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.TelevistoriaAgendada].color,
  'TelevistoriaFinalizada': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.TelevistoriaFinalizada].color,
  'LaudoDevolvido': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.LaudoDevolvido].color,
  'AguardandoCalculosPrestadora': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.AguardandoCalculosPrestadora].color,
};


export const CHART_COLORS = [
  '#1890ff',
  '#52c41a',
  '#faad14',
  '#f5222d',
  '#722ed1',
  '#13c2c2',
  '#eb2f96',
  '#fa8c16',
  '#2f54eb',
  '#a0d911',
];


export const STATUS_LABELS: Record<string, string> = {
  'AguardandoDirecionamento': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.AguardandoDirecionamento].label,
  'AguardandoAceitePrestadora': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.AguardandoAceitePrestadora].label,
  'PrestadoraRecusou': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.PrestadoraRecusou].label,
  'AguardandoDirecionamentoInspetor': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.AguardandoDirecionamentoInspetor].label,
  'AguardandoAceiteInspetor': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.AguardandoAceiteInspetor].label,
  'InspetorRecusou': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.InspetorRecusou].label,
  'AguardandoAgendamento': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.AguardandoAgendamento].label,
  'Agendado': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.Agendado].label,
  'CheckinRealizado': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.CheckinRealizado].label,
  'Finalizado': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.Finalizado].label,
  'Cancelado': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.Cancelado].label,
  'Frustrado': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.Frustrado].label,
  'LaudoNegadoPorPrestadora': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.LaudoNegadoPorPrestadora].label,
  'AguardandoRevisaoBanco': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.AguardandoRevisaoBanco].label,
  'LaudoNegadoPorBanco': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.LaudoNegadoPorBanco].label,
  'LaudoAceitoPeloBanco': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.LaudoAceitoPeloBanco].label,
  'AguardandoRevisaoPrestadora': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.AguardandoRevisaoPrestadora].label,
  'CorrecaoPeloInspetorBanco': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.CorrecaoPeloInspetorBanco].label,
  'AguardandoGeracaoLaudo': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.AguardandoGeracaoLaudo].label,
  'TelevistoriaAgendada': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.TelevistoriaAgendada].label,
  'TelevistoriaFinalizada': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.TelevistoriaFinalizada].label,
  'LaudoDevolvido': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.LaudoDevolvido].label,
  'AguardandoCalculosPrestadora': INSPECTION_ITEM_STATUS_MAP[InspectionItemStatus.AguardandoCalculosPrestadora].label,
};


export function getStatusColor(statusName: string): string {
  
  if (STATUS_COLORS[statusName]) {
    return STATUS_COLORS[statusName];
  }

  
  
  let hash = 0;
  for (let i = 0; i < statusName.length; i++) {
    hash = statusName.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % CHART_COLORS.length;
  return CHART_COLORS[index];
}


export function getStatusLabel(statusName: string): string {
  return STATUS_LABELS[statusName] || statusName;
}


export function getChartColors(count: number, statusNames?: string[]): string[] {
  if (statusNames && statusNames.length > 0) {
    return statusNames.map(name => getStatusColor(name));
  }

  const colors: string[] = [];
  for (let i = 0; i < count; i++) {
    colors.push(CHART_COLORS[i % CHART_COLORS.length]);
  }
  return colors;
}
